<template>
    <div class="pcoded-content">
        <!-- Page header -->
        <div class="page-header card mb-4" style="border: none;">
            <div class="row align-items-baseline">
                <div class="col-xl-7 d-flex justify-content-between align-items-center">
                    <under-bar-name title="História balíčkov" :margin="false" />
                    <div v-if="isFetching" class="d-flex align-items-start">
                        <v-progress-circular indeterminate size="25" width="3" color="primary" />
                        <span class="ml-3 mt-2px font-weight-bold font-size-16px">
                            Načítavam ďalšie riadky… ({{ allRows.length }} / {{ count }})
                        </span>
                    </div>
                </div>
                <div class="col-xl-5"></div>
            </div>
        </div>

        <!-- Table + Search + Legend -->
        <div data-app class="pb-50px">
            <v-card class="mx-auto custom-card">
                <v-data-table :headers="headers" :items="filteredRows" :items-per-page="20" :loading="isFetching"
                    loading-text="" class="elevation-1 custom-table" :footer-props="footerProps">
                    <template #top>
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <v-text-field v-model="searchQuery" append-icon="mdi-magnify" label="Hľadať" solo-inverted
                                clearable hide-details class="email-search" />
                            <div class="change-legend d-flex flex-wrap">
                                <v-chip v-for="(cfg, key) in changeTypes" :key="key" small text-color="white"
                                    class="ma-1 chip-clickable"
                                    :class="[cfg.cssClass, { 'chip-selected': selectedChangeType === parseInt(key) }]"
                                    @click="selectChangeType(key)">
                                    {{ cfg.text }}
                                </v-chip>
                                <v-chip small outlined class="ma-1" @click="resetFilter">
                                    Reset
                                </v-chip>
                            </div>
                        </div>
                    </template>

                    <!-- custom loading overlay -->
                    <template #progress>
                        <v-overlay :value="isFetching" absolute>
                            <v-progress-circular indeterminate size="40" />
                        </v-overlay>
                    </template>

                    <!-- Format subscription date -->
                    <template #[`item.subs_date`]="{ item }">
                        {{ formatSubscriptionDate(item.subs_date) }}
                    </template>

                    <!-- Change type badge -->
                    <template #[`item.change`]="{ item }">
                        <v-chip small text-color="white" :class="getChangeTypeClass(item.change.type)">
                            {{ item.change.text }}
                        </v-chip>
                    </template>

                    <!-- Actions column -->
                    <template #[`item.actions`]="{ item }">
                        <!-- <v-icon color="info" @click="showInfo(item)">
                            mdi-information
                        </v-icon> -->
                        <i v-if="item.invoice_id" class="fa-solid fa-file-arrow-down fa-xl text-success mr-2 cursor-pointer" @click="showInvoice(item)"></i>
                        <i class="fa-solid fa-circle-info text-info fa-xl cursor-pointer" @click="showInfo(item)"></i>
                    </template>r
                </v-data-table>
            </v-card>
        </div>

        <!-- Detail Info Dialog -->
        <v-dialog v-model="infoDialog" max-width="600px">
            <v-card>
                <div class="d-flex justify-content-between align-items-center px-3 pt-2 pb-1">
                    <h1 class="font-weight-bold font-size-23px">Detail užívateľa</h1>
                    <i @click="infoDialog = false" class="fa-regular fa-circle-xmark fa-xl cursor-pointer text-black mb-2 ml-6 opacity-80"></i>
                    
                </div>
                <v-divider class="mb-3 pt-0 h-20px mt-0" />
                <v-card-text>
                    <div v-if="isFetchingInfo" class="text-center my-6">
                        <v-progress-circular indeterminate size="36" />
                    </div>
                    <div v-else-if="infoData">
                        <div class="d-flex justify-content-between align-items-center p-1">
                            <v-col cols="5">
                                <v-row class="mb-4"><strong class="text-uppercase text-15px">Užívateľ</strong></v-row>
                                <v-row class=""><strong>Email:</strong></v-row>
                                <v-row class="mb-1">{{ infoData.user.email || 'N/A' }}</v-row>
                                <v-row class=""><strong>Meno:</strong></v-row>
                                <v-row class="mb-1">{{ infoData.user.name || 'N/A' }}</v-row>
                                <v-row class=""><strong>Dátum poslednej akcie:</strong></v-row>
                                <v-row class="mb-1">{{ infoData.user.date_action || 'N/A' }}</v-row>
                            </v-col>        
                            <v-divider vertical class="mx-4" />              
                            <v-col cols="5">
                                <v-row class="mb-4"><strong class="text-uppercase text-15px">Spoločnosť</strong></v-row>
                                <v-row class=""><strong>Názov:</strong></v-row>
                                <v-row class="mb-1">{{ infoData.company.name || 'N/A' }}</v-row>
                                <v-row class=""><strong>Email:</strong></v-row>
                                <v-row class="mb-1">{{ infoData.company.email || 'N/A' }}</v-row>
                                <v-row class=""><strong>Tel.:</strong></v-row>
                                <v-row class="mb-1">{{ infoData.company.tel || 'N/A' }}</v-row>
                            </v-col>
                        </div>
                        <v-divider />
                        <div class="p-3">
                            <v-row class="mb-2"><strong class="text-uppercase text-15px">Fakturácia</strong></v-row>
                            <v-row class="d-flex justify-content-between">
                            <v-col cols="6">
                                <v-row class=""><strong>Firma:</strong></v-row>
                                <v-row class="mb-1">{{ infoData.invoice.company || 'N/A' }}</v-row>
                                <v-row class=""><strong>Adresa:</strong></v-row>
                                <v-row class="mb-1">{{ infoData.invoice.address || 'N/A' }}</v-row>
                            </v-col>         
                            <v-col cols="6">
                                <v-row class=""><strong>IČO:</strong></v-row>
                                <v-row class="mb-1">{{ infoData.invoice.ico || 'N/A' }}</v-row>
                                <v-row class=""><strong>DIC:</strong></v-row>
                                <v-row class="mb-1">{{ infoData.invoice.dic || 'N/A' }}</v-row>
                                <v-row class=""><strong>IC DPH:</strong></v-row>
                                <v-row class="mb-1">{{ infoData.invoice.icdph || 'N/A' }}</v-row>
                            </v-col>   
                            </v-row>
                        </div>
                    </div>
                    <div v-else class="text-center grey--text">
                        Nepodarilo sa načítať detaily.
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
    props: ['first_rows', 'count'],
    data() {
        return {
            headers: [
                { text: 'Dátum a čas zmeny', align: 'start', sortable: true, value: 'date' },
                { text: 'Doba predplatného', value: 'subs_date' },
                { text: 'Email', value: 'email' },
                { text: 'Typ zmeny', value: 'change' },
                { text: 'Spoločnosť', value: 'company' },
                { text: 'Akcie', value: 'actions', sortable: false, align: 'center' },
            ],
            changeTypes: {
                1: { text: 'Zmena', cssClass: 'chip-blue' },
                2: { text: 'Zrušenie', cssClass: 'chip-orange' },
                3: { text: 'Vymazanie', cssClass: 'chip-red' },
                4: { text: 'Obnovenie', cssClass: 'chip-green' },
                5: { text: 'Koniec trial', cssClass: 'chip-purple' },
                6: { text: 'Vytvorenie', cssClass: 'chip-teal' },
                7: { text: 'Vytvorenie (Admin)', cssClass: 'chip-indigo' },
            },
            selectedChangeType: null,
            allRows: [],
            isFetching: false,
            searchQuery: '',
            infoDialog: false,
            infoData: null,
            isFetchingInfo: false,
            footerProps: {
                'page-text': '{0}-{1} z {2}',
                showFirstLastPage: true,
                firstIcon: 'fa-solid fa-file-arrow-down',
                lastIcon: 'fa-solid fa-file-arrow-down',
                prevIcon: 'fa-solid fa-file-arrow-down',
                nextIcon: 'fa-solid fa-file-arrow-down',
                'items-per-page-options': [20],
            },
        }
    },
    computed: {
        filteredRows() {
            let rows = this.allRows

            // text search filter
            if (this.searchQuery) {
                const q = this.searchQuery.toLowerCase()
                rows = rows.filter(item => {
                    const subs = Array.isArray(item.subs_date) ? item.subs_date.join(' – ') : ''
                    const combined = [
                        item.date, subs, item.email,
                        item.change.text, item.company
                    ].filter(v => !!v).join(' | ').toLowerCase()
                    return combined.includes(q)
                })
            }

            // change-type filter
            if (this.selectedChangeType !== null) {
                rows = rows.filter(item => item.change.type === this.selectedChangeType)
            }

            return rows
        }
    },
    mounted() {
        this.allRows = Array.isArray(this.first_rows) ? [...this.first_rows] : []
        this.fetchRemaining()
    },
    methods: {
        formatSubscriptionDate(dates) {
            if (Array.isArray(dates)) {
                if(!dates[1] && dates[0])
                    return `Od ${dates[0]}`
                if(!dates[0] && dates[1])
                    return `Do ${dates[1]}`
                if(!dates[0] && !dates[1])
                    return 'N/A'
                return `Od ${dates[0]} do ${dates[1]}`
            }
            return 'N/A '
        },
        getChangeTypeClass(type) {
            return this.changeTypes[type]?.cssClass || 'chip-grey'
        },
        selectChangeType(type) {
            this.selectedChangeType = parseInt(type)
        },
        resetFilter() {
            this.selectedChangeType = null
        },
        async fetchRemaining() {
            if (this.allRows.length >= this.count) return
            this.isFetching = true
            try {
                const { data } = await axios.get('/api/subscription/history/next', {
                    params: { from: this.allRows.length }
                })
                this.allRows.push(...data)
            } catch (e) {
                console.error('Failed to load remaining rows', e)
            } finally {
                this.isFetching = false
            }
        },
        showInvoice(item) {
            window.open(`/admin/invoices/${item.invoice_id}`, '_blank')
        },
        showInfo(item) {
            this.infoDialog = true
            this.infoData = item.more_info
        },
    },
}
</script>

<style scoped>
.custom-card {
    width: 95%;
    margin: 20px auto;
}

.custom-table thead th {
    background-color: #f5f5f5;
    font-weight: 600;
}

.custom-table tbody tr:nth-child(odd) {
    background-color: #fafafa;
}

.email-search {
    max-width: 300px;
    margin: 15px;
}

.v-icon {
    cursor: pointer;
}

.change-legend {
    padding: 0 10px;
}

.chip-clickable {
    cursor: pointer;
}

/* Chip background colors */
.chip-grey {
    background-color: #9e9e9e !important;
    color: white !important;
}

.chip-blue {
    background-color: #2196f3 !important;
    color: white !important;
}

.chip-orange {
    background-color: #ff9800 !important;
    color: white !important;
}

.chip-red {
    background-color: #f44336 !important;
    color: white !important;
}

.chip-green {
    background-color: #4caf50 !important;
    color: white !important;
}

.chip-purple {
    background-color: #9c27b0 !important;
    color: white !important;
}

.chip-teal {
    background-color: #009688 !important;
    color: white !important;
}

.chip-indigo {
    background-color: #3f51b5 !important;
    color: white !important;
}

/* Selected legend chip */
.chip-selected {
    box-shadow: 0 0 0 2px #000 inset !important;
}
</style>